import * as THREE from 'three'

export function dropObjectToFloor(object: THREE.Object3D): void {
  const { x, y } = object.position

  object.position.set(0, 0, 0)
  object.updateWorldMatrix(true, true)

  const box = new THREE.Box3().setFromObject(object)
  if (object.parent) box.applyMatrix4(object.parent.matrixWorld.clone().invert())

  object.position.set(x, y, -box.min.z)
  object.updateWorldMatrix(true, true)
}
